export function countActiveFilterValues(
  values: Readonly<Record<string, unknown>>,
  defaults: Readonly<Record<string, unknown>> = {},
): number {
  return Object.entries(values).filter(([key, value]) => {
    const normalized = normalize(value);
    if (normalized === null || normalized === '' || normalized === false) return false;
    return normalized !== normalize(defaults[key]);
  }).length;
}

function normalize(value: unknown): unknown {
  return typeof value === 'string' ? value.trim() : (value ?? null);
}
